import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import type React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useShortLocale } from '#configuration/lang/useLocale.ts';

type DialogFooterProps = {
    onSubmitTour: () => void;
    setNotificationsEnabled: (enable: boolean) => void;
    notificationsEnabled: boolean;
    isMisplaced: boolean;
    isLoading: boolean;
    submitLabel?: string;
    submitTrackingKey: string;
    extraAction?: React.ReactNode;
};
export const DialogFooter = ({
    onSubmitTour,
    isMisplaced,
    isLoading,
    setNotificationsEnabled,
    notificationsEnabled,
    submitLabel,
    submitTrackingKey,
    extraAction,
}: DialogFooterProps) => {
    const locale = useShortLocale();
    const intl = useIntl();
    return (
        <ButtonToolbar alignment={'space-between'} className={'width-100pct align-items-center'}>
            <Checkbox
                checked={notificationsEnabled}
                id='tour-notifications'
                onChange={() => setNotificationsEnabled(!notificationsEnabled)}
            >
                <span>
                    <FormattedMessage
                        id='intl-msg:ordercom-cloud-frontend.tours.create-dialog.notifications-link'
                        values={{
                            link: (chunks: React.ReactNode) => (
                                <a
                                    href={`https://rio.cloud/${locale}/documents/manuals/notifications-through-the-bell-icon`}
                                    target='_blank'
                                    rel='noreferrer'
                                    {...getTrackingAttributes({
                                        trigger: 'click',
                                        category: 'link autoTracking',
                                        action: 'link click',
                                        label: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.notifications-link',
                                    })}
                                >
                                    {chunks}
                                </a>
                            ),
                        }}
                    />
                </span>
            </Checkbox>
            <div className='display-flex flex-wrap justify-content-end gap-10'>
                {extraAction}
                <Button
                    disabled={isMisplaced || isLoading}
                    bsStyle='primary'
                    autoTrackingKey={submitTrackingKey}
                    onClick={() => {
                        onSubmitTour();
                    }}
                    iconName='ok'
                >
                    {submitLabel ??
                        intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.title',
                        })}
                </Button>
            </div>
        </ButtonToolbar>
    );
};
